export const formatDayMonthWord = (anyDate?: Date | string) => {
  if (!anyDate) {
    return '';
  }
  const currentDate = new Date(anyDate);
  return currentDate.toLocaleString('ru-RU', {
    month: 'long',
    day: 'numeric',
  });
};
